export const FIELD_ID = {
  plaintiff: {
    product: 1203914,
    currentDiagnosis: 1201214,
    status: 1202714,
    dismissalInformation: 16348660,
    gender: 16363354,
  },
}

export const CHOICE_VALUE = {
  product: {
    TEC: 1118564,
  },
  currentDiagnosis: {
    mesothelioma: 1127714,
  },
  plaintiffStatus: {
    open: 7405364,
  },
}

